module.exports = __webpack_public_path__ + "static/media/warning.5d85ca32.svg";